<template>
  <div class="page_tePayment">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" v-loading="loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>暂支</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/logReimbursement',query:{
            activeName:'6',tabName:'待打款'
          } }">待打款</el-breadcrumb-item>
          <el-breadcrumb-item>打款</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="descriptions_box" id="printBox">
          <div class="descriptionsTitle" style="width:798px">{{reiForm.companyName}}</div>
          <!-- <div class="descriptionsTitle" style="color: #666;width:798px">工资发放申请</div> -->
          <el-descriptions :column="4" border :contentStyle="CS" :label-style="LS " style="width:800px;">

            <el-descriptions-item label="签单部门" :span="2" :contentStyle="{'max-width': '200px','min-width': '200px','text-align': 'center'}"></el-descriptions-item>
            <el-descriptions-item label="业务员" :span="2">{{reiForm.writtenName}}</el-descriptions-item>

            <el-descriptions-item label="服务部门" :span="2"></el-descriptions-item>
            <el-descriptions-item label="客服" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}"></el-descriptions-item>
            <el-descriptions-item label="申请日期" :contentStyle="{'max-width': '120px','min-width': '120px','text-align': 'center'}">{{reiForm.reimbTime ? reiForm.reimbTime.split('T')[0] : ''}}</el-descriptions-item>

            <el-descriptions-item label="所属项目" :span="2">{{reiForm.projectName}}</el-descriptions-item>
            <el-descriptions-item label="客户名称" :span="2">{{reiForm.CustomerName }}</el-descriptions-item>

            <el-descriptions-item label="内容" :span="2">{{ }}</el-descriptions-item>
            <el-descriptions-item label="业务属性" :span="2"></el-descriptions-item>

            <el-descriptions-item label="金额 大写(RMB)" :span="2">{{ numberToChinese(reiForm.writtenAmount) }}</el-descriptions-item>
            <el-descriptions-item label="￥：" :span="2">{{reiForm.writtenAmount}}</el-descriptions-item>

            <el-descriptions-item label="备注" :span="4">{{reiForm.applyRemark}}</el-descriptions-item>

            <el-descriptions-item label="申请人" :span="2">{{reiForm.writtenName}}</el-descriptions-item>
            <el-descriptions-item label="业务审核" :span="2"></el-descriptions-item>

            <el-descriptions-item label="出纳确认" :span="2"></el-descriptions-item>
            <el-descriptions-item label="出纳" :span="2"></el-descriptions-item>

          </el-descriptions>
        </div>

        <div>
          <el-form :model="reiForm" :rules="rules" ref="payForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="打款金额" prop="writtenAmount">
              <div class="payInput">
                <el-input v-model="reiForm.writtenAmount" size="small" style="width:300px" @input="payInput" type="number">
                  <i slot="prepend">￥</i>
                </el-input>
              </div>
            </el-form-item>
            <el-form-item label="收款人" prop="writtenName">
              <el-input v-model="reiForm.writtenName" size="small" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="银行开户行" prop="depositBank">
              <el-input v-model="reiForm.depositBank" size="small" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item label="银行卡号" prop="bankAccount">
              <el-input v-model="reiForm.bankAccount" size="small" style="width:300px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="UpdateLogReimbursementAccount">保存修改</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div class="flex aic">
          <div class="Reititle"><span class="titleLine">|</span>报销单</div>
          <el-button type="text" style="margin-left:30px" @click="printClick('printBox','')">打印/下载</el-button>
        </div>
        <div>
          <div id="printBox" class="printBox">
            <div v-for="(item,index) in rei" :key="index" :class="index%2==0 && index!=0  ? 'reiItem mt' : 'reiItem'" v-if="companyName == item.companyName">
              <div class="reiTop flex">
                <div>
                  <div class="reiType">工作日志</div>
                  <div class="reiRnumber">NO:{{reiForm.advanceNum}}</div>
                </div>
                <div class="centerTitle">
                  <div class="reimbursementTitle">报&nbsp;&nbsp;&nbsp;&nbsp;销&nbsp;&nbsp;&nbsp;&nbsp;单</div>
                  <hr width="130px" color="#000" style="margin-top:-1px;border-color:#000" height="1px">
                  <hr width="130px" color="#000" style="margin-top:-5px;border-color:#000">
                </div>
                <div class="flex sb aic reiTopRight">
                  <div class="accountBox">
                    <div class="accountName">付款：</div>
                    <div class="accountName">收款：{{reiForm.writtenName}}</div>
                  </div>
                  <div class="qrcode">
                    <img src="./../../assets/images/qrcode.png" alt="">
                  </div>
                </div>
              </div>
              <div class="reiInfo flex sb">
                <div class="flex">
                  <div>公司名称：</div>
                  <div class="answer">{{item.companyName}}</div>
                  <!-- <div class="answer">{{writeOffData[0].depName ? writeOffData[0].depName[writeOffData[0].depName.length - 1] : ''}}</div> -->
                </div>
                <div class="flex aic reiDate">
                  <div class="answer2">{{moment(reiForm.reimbTime).year()}}</div>
                  <div>年</div>
                  <div class="answer2">{{moment(reiForm.reimbTime).month() + 1}}</div>
                  <div>月</div>
                </div>
              </div>
              <table width="99%" border="0" cellspacing="1" cellpadding="4" class="tabtop13" align="center">
                <tr>
                  <td colspan="2" class="font-center titfont">发生日期</td>
                  <td width="35%" class="font-center titfont" rowspan="2">报销内容</td>
                  <td width="6%" class="font-center titfont" rowspan="2">单据张数</td>
                  <td colspan="9" class="font-center titfont">金额</td>
                  <td class="font-center titfont" rowspan="2">备注</td>
                </tr>
                <tr>
                  <td width="5%" class="font-center">月</td>
                  <td width="5%" class="font-center">日</td>
                  <td width="3%" class="font-center">百</td>
                  <td width="3%" class="font-center">十</td>
                  <td width="3%" class="font-center">万</td>
                  <td width="3%" class="font-center">千</td>
                  <td width="3%" class="font-center">百</td>
                  <td width="3%" class="font-center">十</td>
                  <td width="3%" class="font-center">元</td>
                  <td width="3%" class="font-center">角</td>
                  <td width="3%" class="font-center">分</td>
                </tr>
                <tr v-for="(row,index) in item.reiData" :key="index">
                  <td class="font-center">{{row.occurDate ? moment(row.occurDate).month() + 1 : ''}}</td>
                  <td class="font-center">{{row.occurDate ? moment(row.occurDate).date() : ''}}</td>
                  <td class="font-center">{{row.reimbursementContent}}</td>
                  <td class="font-center">{{row.documentsNum}}</td>
                  <td class="font-center">{{getNum(row.amounts,'bw')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'sw')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'w')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'q')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'b')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'s')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'g')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'j')}}</td>
                  <td class="font-center">{{getNum(row.amounts,'f')}}</td>
                  <td class="font-center">{{row.remark}}</td>
                </tr>
                <tr>
                  <td colspan="4">合计人民币（大写） {{numberToChinese(item.sum)}}</td>
                  <td class="font-center">{{getNum(item.sum,'bw')}}</td>
                  <td class="font-center">{{getNum(item.sum,'sw')}}</td>
                  <td class="font-center">{{getNum(item.sum,'w')}}</td>
                  <td class="font-center">{{getNum(item.sum,'q')}}</td>
                  <td class="font-center">{{getNum(item.sum,'b')}}</td>
                  <td class="font-center">{{getNum(item.sum,'s')}}</td>
                  <td class="font-center">{{getNum(item.sum,'g')}}</td>
                  <td class="font-center">{{getNum(item.sum,'j')}}</td>
                  <td class="font-center">{{getNum(item.sum,'f')}}</td>
                  <td class="font-center"></td>
                </tr>
                <tr>
                  <td colspan="2">主管意见</td>
                  <td colspan="2" class="font-center"></td>
                  <td colspan="9">报销人签章</td>
                  <td class="font-center">{{reiForm.writtenName}}</td>
                </tr>
              </table>
              <div class="flex reiBot">
                <div>批准：</div>
                <div class="reiBotInfo"></div>
                <div>复核：</div>
                <div class="reiBotInfo"></div>
                <div>报销人：</div>
                <div class="reiBotInfo">{{reiForm.writtenName}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="botbox">
          <el-button type="primary" size="small" v-preventReClick @click="payByCBS" :disabled="isPaySuccess">提交CBS打款</el-button>
          <el-button type="success" size="small" v-preventReClick @click="handel('1')" :disabled="isPaySuccess">登记手工打款成功</el-button>
          <el-button type="danger" size="small" v-preventReClick @click="handel('2')" :disabled="isPaySuccess">登记手工打款失败</el-button>
          <el-button size="small" @click="cancel">返 回</el-button>
        </div>

      </div>
    </div>

    <el-dialog width="700px" title="选择打款账号" :visible.sync="innerVisibleCA">
      <div class="salaryPayingCompanyBox" v-if="BankAccount.length > 0">
        <div class="salaryPayingCompany">打款公司：{{ companyName }}</div>
        <div class="salaryPayingCompany_radio">
          <el-radio :label="bank.Account" v-for="bank in BankAccount" :key="bank.Account" style="margin-bottom: 10px;" v-model="payForm.payAccount">开户行：{{ bank.OpeningBank }} 帐号：{{
          bank.Account
        }}</el-radio>
        </div>
      </div>
      <div v-else class="noAccountTips">暂未配置打款公司CBS银行账户</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="innerVisibleCA = false" size="small">取 消</el-button>
        <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" size="small" @click="confirmPay">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          busiId: '',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        tableData: [{
          name: '666'
        }],
        activeName: 0,
        rules: {
          writtenAmount: {
            required: true,
            message: "请输入打款金额",
            trigger: "blur",
          },
          writtenName: {
            required: true,
            message: "请输入收款人",
            trigger: "blur",
          },
          depositBank: {
            required: true,
            message: "请输入银行开户行",
            trigger: "blur",
          },
          bankAccount: {
            required: true,
            message: "请输入银行卡号",
            trigger: "blur",
          }
        },
        reiForm: {},
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        loading: false,
        BankAccount: [], //银行列表
        isBtnLoading: false,
        innerVisibleCA: false,
        rei: [],
        depName: '',
        isPaySuccess: false,
        payForm: {
          id: '',
          TotalFees: '', //打款金额
          payAccount: '', //打款账号
          BusiType: '2', //1暂支 2 工作日志
          ProcessState: '1', //是否需要核销，为1是需要核销，为0是不用核销
          UseFunds: '', //款项用途
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        },
        showMore: false, //展开OA信息
        CS: {
          'text-align': 'center', //文本居中
          'min-width': '200px', //最小宽度
          'max-width': '200px',
          'word-break': 'break-all'
        },
        LS: {
          'background-color': 'fff',
          'text-align': 'center', //文本居中
          'min-width': '100px', //最小宽度
          'max-width': '100px',
        },
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
        this.writeOffId = this.$route.query.id;
        // this.companyName = this.$route.query.companyName;
        this.GetWriteoffDetail();
      }
    },
    methods: {
      checkPermission,
      //获取暂支报销详情
      GetWriteoffDetail() {
        this.loading = true;
        let data = {
          busiId: this.writeOffId,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.GetWriteoffDetail(data).then(res => {
          if (res.status == 'ok') {
            this.reiForm = res.data;
            this.companyName = res.data.companyName;
            this.$set(this.reiForm, 'userId', Cookies.get("userid-b"));
            this.$set(this.reiForm, 'roleType', localStorage.loginRoletype);
            this.writeOffData = eval(res.data.reimbContent);
            if (res.data.depName) {
              this.reiForm.depName = res.data.depName.split(',');
              this.depName = this.reiForm.depName[this.reiForm.depName.length - 1];
            }
            this.complete();
            this.loading = false;
            // this.fileList = res.data.materAcces;
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      complete() {
        this.getTotalAmounts();
        setTimeout(() => {
          this.rei = JSON.parse(JSON.stringify(this.writeOffData));
          let data2 = {
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            documentsNum: '', //单据张数
            amounts: '', //金额
            remark: '', //备注
          }
          this.rei.forEach(element => {
            let l = element.reiData.length;
            for (var j = 0; j < 6 - l; j = j + 1) {
              element.reiData.push(data2)
            }
          });
        }, 100);
      },
      //获取总金额
      getTotalAmounts() {
        this.rei.forEach(element => {
          let sum = 0;
          element.reiData.forEach(e => {
            sum = sum + Number(e.amounts)
          });
          this.$set(element, 'sum', sum)
        });
        // let sum2 = 0;
        // this.writeOffData.forEach(element => {
        //   sum2 = sum2 + Number(element.amounts)
        // });
        // this.reiForm.writtenAmount = sum2;
      },
      getNum(num, t) {
        if (num != undefined && num) {
          num = Number(num)
          let result = '';
          let c = '';
          switch (t) {
            case 'j':
              c = num.toFixed(2).split('.')[1]
              result = parseInt((c % 100) / 10)
              break;
            case 'f':
              c = num.toFixed(2).split('.')[1]
              result = parseInt(c % 10)
              break;
            case 'g':
              result = parseInt(num % 10)
              break;
            case 's':
              if (num < 10) {
                result = ''
              } else {
                result = parseInt((num % 100) / 10)
              }
              break;
            case 'b':
              if (num < 100) {
                result = ''
              } else {
                result = parseInt((num % 1000) / 100)
              }
              break;
            case 'q':
              if (num < 1000) {
                result = ''
              } else {
                result = parseInt((num % 10000) / 1000)
              }
              break;
            case 'w':
              if (num < 10000) {
                result = ''
              } else {
                result = parseInt((num % 100000) / 10000)
              }
              break;
            case 'sw':
              if (num < 100000) {
                result = ''
              } else {
                result = parseInt((num % 1000000) / 100000)
              }
              break;
            case 'bw':
              if (num < 1000000) {
                result = ''
              } else {
                result = parseInt((num % 10000000) / 1000000)
              }
              break;
          }
          // let n2 = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
          return result
        }
      },
      //数字转中文大写
      numberToChinese(money) {
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      changeTab() {},
      //登记成功/失败
      handel(type) {
        this.loading = true;
        let data = [{
          id: this.id,
          payResult: type, //1代表成功,0为失败
          TotalFees: this.reiForm.writtenAmount, //打款金额
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }]
        xz.AdvanceFun(data, 'LogVerifPayResult').then(res => {
          try {
            if (res.status == 'ok') {
              this.$message.success('保存成功！');
              this.loading = false;
            } else {
              this.loading = false;
              this.$message.error(res.msg);
            }
          } catch (e) {
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      //cbs打款
      payByCBS() {
        this.payForm.TotalFees = this.reiForm.writtenAmount;
        this.payForm.id = this.id;
        this.payForm.payAccount = '';
        xz.getCompfinanceSet(this.companyName, this.roletype).then(res => {
          if (res.status == 'ok') {
            if (!res.data.BankAccountJ) {
              this.BankAccount = []
            } else {
              res.data.BankAccountJ.forEach(element => {
                if (element.IsDefault != undefined && element.IsDefault == '1') {
                  this.payForm.payAccount = element.Account
                }
              });
              this.BankAccount = res.data.BankAccountJ;
              this.innerVisibleCA = true;
            }
          } else {
            this.BankAccount = [];
          }
        })
      },
      confirmPay() {
        if (this.payForm.TotalFees > this.reiForm.totalFees) {
          this.$message.warning('打款金额不能大于申请金额')
        } else if (!this.payForm.payAccount) {
          this.$message.warning('请选择打款账号')
        } else {
          this.isBtnLoading = true;
          // console.log(this.payForm)
          xz.cbsPayAdvance(this.payForm, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.$message.success('打款成功！');
              this.isBtnLoading = false;
              this.innerVisibleCA = false;
              this.isPaySuccess = true;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
              this.innerVisibleCA = false;
            }
          })
        }
      },
      cancel() {
        // this.$router.go(-1);
        window.close();
      },
      //附件
      toDownFile(row) {
        const newWindow = window.open(url, "_blank");
      },
      payInput(val) {
        this.payForm.TotalFees = Number(val).toFixed(2)
      },
      UpdateLogReimbursementAccount() {
        let data = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          id: this.id,
          bankAccount: this.reiForm.bankAccount,
          depositBank: this.reiForm.depositBank,
          writtenName: this.reiForm.writtenName
        };
        this.isBtnLoading = true;
        xz.AdvanceFun(data, 'UpdateLogReimbursementAccount').then(res => {
          if (res.status == 'ok') {
            this.$message.success('银行卡信息修改成功！');
            this.isBtnLoading = false;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .showPaymentInfo {
    // width: 1161px;
  }

  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .showMore {
    width: 1088px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    text-align: center;
    margin-top: -1px;
    border: 1px solid #ebebeb;
    border-top: 1px solid #eaeefb;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .descriptions_box {
    margin-bottom: 20px;
  }

  .descriptionsTitle {
    border: 1px solid #B7BABD;
    border-bottom: none;
    // margin: 0 auto;
    padding: 8px 0;
    font-size: 13px;
    font-weight: 600;
    color: #000;
    text-align: center;
  }

  .botbox {
    margin-top: 30px;
    padding-bottom: 20px;
  }

  .salaryPayingCompanyItem {
    margin-bottom: 30px;
  }

  .salaryPayingCompany {
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 15px;
  }

  .salaryPayingCompany_radio {
    padding-left: 30px;
  }

  .reiTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  }

  .reiRnumber {
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }

  .reimbursementTitle {
    text-align: center;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 24px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .centerTitle {
    // width: 300px;
    margin-bottom: 5px;
    font-size: 20px;
  }

  .centerTitle hr {
    margin: 10px auto 0;
  }

  .reiTopRight {
    // width: 300px;
  }

  .accountBox {
    font-size: 14px;
  }

  .qrcode {
    // margin-left: 80px;
    width: 50px;
    height: 50px;
  }

  .qrcode img {
    width: 50px;
    height: 50px;
  }

  .reiInfo {
    font-size: 14px;
    white-space: nowrap;
  }

  .answer {
    border-bottom: 1px solid #000;
    padding: 0 15px 3px;
    margin: 0 10px;
    min-width: 100px;
  }

  .answer2 {
    border-bottom: 1px solid #000;
    padding: 0 5px;
    margin: 0 3px;
  }

  .reiDate {
    padding-right: 55px;
  }

  .reiBot {
    font-size: 14px;
    margin-top: 5px;
    font-weight: bold;
    white-space: nowrap;
  }

  .reiBotInfo {
    width: 80px;
  }

  .tabtop13 {
    margin-top: 5px;
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .tabtop15 td {
    padding: 8px;
    word-break: break-word;
    font-size: 14px;
  }

  .font-center {
    text-align: center
  }

  .biaoti {
    font-family: 微软雅黑;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px dashed #CCCCCC;
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
    // background: url(../images/ico3.gif) no-repeat 15px center;
  }

  .bttit {
    background: #F6F6F6 !important;
  }

  .tabtxt2 {
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
  }

  .tabtxt3 {
    font-family: 微软雅黑;
    font-size: 14px;
    padding-left: 15px;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .printBox {
    width: 800px;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
  }

  .accountName {
    min-width: 100px;
  }

  .Reititle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }
</style>
<style>
  .page_tePayment .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePayment .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tePayment .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePayment .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePayment .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 1px solid #B7BABD;
  }

  .payInput .el-input-group__append,
  .payInput .el-input-group__prepend {
    padding: 0 0 0 5px;
    background: #fff;
    border-right: none !important;
  }

  .payInput .el-input__inner {
    border-left-color: #fff;
    padding-left: 3px;
  }
</style>